import "./hall-video.css";
import video from "../../../../Assets/Hall/kosuta-video.mp4";

export default function HallVideo() {
  return (
    <div className="hall-video">
      <video autoPlay muted loop playsInline>
        <source src={video}></source>
      </video>
    </div>
  );
}
